export default __webpack_public_path__ + "static/media/discord.79129ca4.png";